import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { leaveEntitlementByEmployeeTourSteps } from "./leaveEntitlementByEmployeeTourSteps";
import { useLeaveTour } from "./useLeaveTour";

const TOUR_STORAGE_KEY = "hr-leave-entitlement-by-employee-tour-completed";

type LeaveEntitlementByEmployeeTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
  }) => void;
};

export function LeaveEntitlementByEmployeeTour({
  run,
  onCallback,
}: LeaveEntitlementByEmployeeTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={leaveEntitlementByEmployeeTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useLeaveEntitlementByEmployeeTour() {
  return useLeaveTour(TOUR_STORAGE_KEY);
}
